'use strict';

angular.module('msCore').service('windowSvc', ['$window', 'domainSvc', function ($window, domainSvc) {
  function _windowNavigate(destinationUrl) {
    $window.location.href = destinationUrl;
  }

  function _isLogoutRoute() {
    return new RegExp('logout$', 'i').test($window.location.pathname);
  }

  function _getRedirectUrl() {
    return encodeURI($window.location.pathname + $window.location.search);
  }

  function _getApiUrl() {
    return $window.MYSTRENGTH.API_URL || 'https://api.mystrength.com';
  }

  function _getSpInitiatedSSOUrl() {
    return _getApiUrl() + '/public/sso/livongo/sprequest';
  }

  function _goToAppV2OnboardingLanding() {
    _windowNavigate(domainSvc.getAppV2Domain() + '/login/v2/sso/landing');
  }

  return {
    windowNavigate: _windowNavigate,
    getRedirectUrl: _getRedirectUrl,
    getApiUrl: _getApiUrl,
    getSpInitiatedSSOUrl: _getSpInitiatedSSOUrl,
    getFullyQualifiedRedirectUrl: domainSvc.getFullyQualifiedRedirectUrl,
    isLogoutRoute: _isLogoutRoute,
    goToAppV2OnboardingLanding: _goToAppV2OnboardingLanding
  };
}]);